import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={47.79}
      height={53.021}
      viewBox="0 0 47.79 53.021"
      {...props}
    >
      <g data-name="018---Email">
        <path
          d="M18.151 5.231l3.947-3.646a2.645 2.645 0 013.593 0l3.95 3.646z"
          fill="#ff9801"
        />
        <path
          data-name="Shape"
          d="M5.31 17.081V24.4l-4.089-3.177a3.423 3.423 0 01.805-1.115z"
          fill="#ff9801"
        />
        <path
          data-name="Shape"
          d="M19.665 35.569L2.142 51.03a4.078 4.078 0 01-1.257-2.956V22.71a3.419 3.419 0 01.336-1.487L5.31 24.4z"
          fill="#ffdf00"
        />
        <path
          data-name="Shape"
          d="M45.648 51.03a3.935 3.935 0 01-2.743 1.106H4.885a3.935 3.935 0 01-2.743-1.106l17.523-15.461 3.142 2.443a1.755 1.755 0 002.177 0l3.138-2.443z"
          fill="#ffeb3a"
        />
        <path
          data-name="Shape"
          d="M46.905 22.71v25.364a4.078 4.078 0 01-1.26 2.956l-17.52-15.461L42.48 24.4l4.089-3.177a3.419 3.419 0 01.336 1.487z"
          fill="#ffdf00"
        />
        <path
          data-name="Shape"
          d="M46.569 21.223l-2.319 1.8V48.07a4.088 4.088 0 01-.285 1.47l1.681 1.486a4.078 4.078 0 001.258-2.952V22.71a3.419 3.419 0 00-.336-1.487z"
          fill="#fec108"
        />
        <path
          data-name="Shape"
          d="M46.569 21.223L42.48 24.4v-7.319l3.283 3.027a3.423 3.423 0 01.806 1.115z"
          fill="#ff9801"
        />
        <path
          data-name="Shape"
          d="M42.48 7.001v17.4L28.125 35.569l-3.142 2.442a1.755 1.755 0 01-2.177 0l-3.142-2.443L5.31 24.4V7.001a1.775 1.775 0 011.77-1.77h33.63a1.775 1.775 0 011.77 1.77z"
          fill="#f5f5f5"
        />
        <path
          data-name="Shape"
          d="M40.709 5.231h-2.655a1.775 1.775 0 011.77 1.77v17.4L25.467 35.569l-2.9 2.257.239.186a1.755 1.755 0 002.177 0l3.142-2.443L42.479 24.4V7.001a1.775 1.775 0 00-1.77-1.77z"
          fill="#cfd8dc"
        />
        <g data-name="Group 563">
          <path
            data-name="Shape"
            d="M0 22.711v25.363a4.922 4.922 0 004.885 4.947H42.9a4.922 4.922 0 004.885-4.947V22.711a4.447 4.447 0 00-1.427-3.252l-3-2.764V7.001a2.655 2.655 0 00-2.648-2.655H29.985l-3.69-3.41a3.54 3.54 0 00-4.8 0l-3.692 3.41H7.08a2.655 2.655 0 00-2.655 2.655v9.692l-3 2.765A4.449 4.449 0 000 22.711zm18.279 12.9L2.251 49.753a3.2 3.2 0 01-.481-1.679V22.771zM4.885 51.251a3.022 3.022 0 01-1.311-.305L19.7 36.717l2.557 1.994a2.633 2.633 0 003.274 0l2.569-2 16.115 14.235a3.022 3.022 0 01-1.311.305zm41.135-28.48v25.3a3.2 3.2 0 01-.481 1.681L29.511 35.611zm-.858-2.013a2.663 2.663 0 01.229.26l-2.026 1.575v-3.492zM22.7 2.233a1.763 1.763 0 012.389 0l2.287 2.113h-6.963zM7.08 6.116h33.63a.885.885 0 01.885.885V23.97l-17.16 13.347a.866.866 0 01-1.085 0L6.195 23.97V7.001a.885.885 0 01.885-.885zM4.425 19.101v3.492L2.4 21.018a2.635 2.635 0 01.227-.259z"
          />
          <path
            data-name="Shape"
            d="M23.895 30.896a10.525 10.525 0 006.315-2.077.885.885 0 00-1.055-1.421 8.761 8.761 0 01-5.26 1.728 8.85 8.85 0 118.85-8.85v1.77a1.77 1.77 0 11-3.54 0v-6.195a.885.885 0 10-1.77 0v.478a5.31 5.31 0 10.46 7.428 3.528 3.528 0 006.62-1.711v-1.77a10.62 10.62 0 10-10.62 10.62zm0-7.08a3.54 3.54 0 113.54-3.54 3.54 3.54 0 01-3.54 3.54z"
          />
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
